import { CookieManager } from './cookie-manager.js';
import { DrawerManager } from "./drawer-manager.js";
import { ModalManager } from "./modal-manager.js";
import { NewsletterManager } from './newsletter-manager.js';


/**
 * Document ready
 */
document.addEventListener('DOMContentLoaded', async () => {
    DrawerManager.attachOpenDrawerButton('mobile-menu-btn', 'mobile-menu');
    ModalManager.setupButtonsWithModalData();
    NewsletterManager.initNewsletterForms();
    storeSource();
});

/**
 * Extrae el parámetro rml_source de la URL y lo guarda en una cookie
 */
const storeSource = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('rml_source');

    if (source) {
        CookieManager.set('rml_source', JSON.stringify({ currentValue: source }), 30);
    }
};